import _implicitStylesheets from "./listingDetailV2.css";
import _implicitScopedStylesheets from "./listingDetailV2.scoped.css?scoped=true";
import _axImage from "ax/image";
import _wdsStatusBadge from "wds/statusBadge";
import _wdsIconInteractive from "wds/iconInteractive";
import _listingAwardDeck from "listing/awardDeck";
import _listingBannerV2 from "listing/bannerV2";
import _wdsTabGroupV2 from "wds/tabGroupV2";
import _listingSkillSidebar from "listing/skillSidebar";
import _listingPluginSidebar from "listing/pluginSidebar";
import _listingPricingSummaryV2 from "listing/pricingSummaryV2";
import _wdsButton from "wds/button";
import _axTooltip from "ax/tooltip";
import _listingMetadataCardV2 from "listing/metadataCardV2";
import _aceQualifiedChat from "ace/qualifiedChat";
import _axScopedNotification from "ax/scopedNotification";
import _listingOverviewV2 from "listing/overviewV2";
import _listingSkillOverview from "listing/skillOverview";
import _listingCompetenciesV2 from "listing/competenciesV2";
import _listingPluginSpecs from "listing/pluginSpecs";
import _listingSkillFoundIn from "listing/skillFoundIn";
import _listingPricingV2 from "listing/pricingV2";
import _listingMoreResourcesV2 from "listing/moreResourcesV2";
import _listingSupport from "listing/support";
import _listingSkillPackageFiles from "listing/skillPackageFiles";
import _listingRelatedSkills from "listing/relatedSkills";
import _listingMoreFromThisProviderV2 from "listing/moreFromThisProviderV2";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h1 type-style="display-5" tabindex="0"${3}>${"t1"}</h1>`;
const $fragment2 = parseFragment`<div class="summary-details${0}"${2}><p class="summary-description${0}" type-style="body-2"${2}>${"t2"}</p></div>`;
const $fragment3 = parseFragment`<div class="claudeforce-header-art${0}" data-testid="claudeforce-header-art" aria-hidden="true"${2}><img class="claudeforce-header-art__partnership${0}" src="/images/listing/claudeforce-partnership.svg" alt=""${2}><img class="claudeforce-header-art__spark claudeforce-header-art__spark--one${0}" src="/images/listing/claudeforce-spark-right.png" alt=""${2}><img class="claudeforce-header-art__spark claudeforce-header-art__spark--two${0}" src="/images/listing/claudeforce-spark-left.png" alt=""${2}><img class="claudeforce-header-art__spark claudeforce-header-art__spark--three${0}" src="/images/listing/claudeforce-spark-right.png" alt=""${2}><img class="claudeforce-header-art__spark claudeforce-header-art__spark--four${0}" src="/images/listing/claudeforce-spark-right.png" alt=""${2}><img class="claudeforce-header-art__spark claudeforce-header-art__spark--five${0}" src="/images/listing/claudeforce-spark-extra.png" alt=""${2}></div>`;
const $fragment4 = parseFragment`<span class="collapsed-title${0}" type-style="display-8"${2}>${"t1"}</span>`;
const stc0 = {
  "listing-detail-wrapper": true
};
const stc1 = {
  "grid": "",
  "axis": "row"
};
const stc2 = {
  classMap: {
    "listing-logo": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "listing-title": true
  },
  key: 4
};
const stc4 = {
  classMap: {
    "listing-name-row": true
  },
  key: 5
};
const stc5 = {
  classMap: {
    "listing-heading": true
  },
  key: 6
};
const stc6 = {
  classMap: {
    "listing-status-badge": true
  },
  attrs: {
    "data-testid": "skill-beta-badge"
  },
  props: {
    "variant": "beta"
  },
  key: 9
};
const stc7 = {
  "data-testid": "add-favorites-btn"
};
const stc8 = {
  "award-deck": true
};
const stc9 = {
  "data-testid": "offer-request-success-banner"
};
const stc10 = {
  "data-testid": "private-listing-banner"
};
const stc11 = {
  classMap: {
    "collapsed-nav-reveal": true
  },
  key: 19
};
const stc12 = {
  classMap: {
    "collapsed-nav-inner": true
  },
  key: 20
};
const stc13 = {
  classMap: {
    "collapsed-nav-row": true
  },
  key: 21
};
const stc14 = {
  classMap: {
    "collapsed-header": true
  },
  key: 22
};
const stc15 = {
  "data-id": "collapsed-tab-group"
};
const stc16 = {
  classMap: {
    "listing-content": true
  },
  attrs: {
    "grid": "",
    "axis": "row"
  },
  key: 27
};
const stc17 = {
  classMap: {
    "side-panel": true
  },
  key: 28
};
const stc18 = {
  classMap: {
    "install-card": true
  },
  attrs: {
    "data-testid": "install-card"
  },
  key: 29
};
const stc19 = {
  "price-cta-card": true
};
const stc20 = {
  classMap: {
    "listing-price": true
  },
  key: 33
};
const stc21 = {
  "listing-actions": true
};
const stc22 = {
  "data-testid": "get-it-now-btn"
};
const stc23 = {
  "data-testid": "get-it-now-btn-disabled"
};
const stc24 = {
  "trial-button": true
};
const stc25 = {
  "request-private-offer-button": true
};
const stc26 = {
  "data-testid": "request-private-offer-button"
};
const stc27 = {
  "data-testid": "learn-more-btn"
};
const stc28 = {
  classMap: {
    "qualified-chat-container": true
  },
  key: 43
};
const stc29 = {
  classMap: {
    "tab-column": true
  },
  key: 45
};
const stc30 = {
  classMap: {
    "tab-navigation": true
  },
  key: 46
};
const stc31 = {
  "data-testid": "claudeforce-beta-signup-success"
};
const stc32 = {
  classMap: {
    "tab-bar": true
  },
  key: 48
};
const stc33 = {
  "data-id": "tab-group"
};
const stc34 = {
  "data-testid": "overview-panel"
};
const stc35 = {
  "data-testid": "skill-overview-panel"
};
const stc36 = {
  "data-testid": "security-panel"
};
const stc37 = {
  "data-testid": "competencies-panel"
};
const stc38 = {
  "data-testid": "specs-panel"
};
const stc39 = {
  "data-testid": "plugin-specs-panel"
};
const stc40 = {
  "data-testid": "found-in-panel"
};
const stc41 = {
  "data-testid": "reviews-panel"
};
const stc42 = {
  "data-testid": "pricing-panel"
};
const stc43 = {
  "data-testid": "resources-panel"
};
const stc44 = {
  "data-testid": "support-panel"
};
const stc45 = {
  "data-testid": "skill-package-files-panel"
};
const stc46 = {
  "data-testid": "related-skills"
};
const stc47 = {
  "data-testid": "more-from-provider-band"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, ncls: api_normalize_class_name, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, gid: api_scoped_id, ddc: api_deprecated_dynamic_component} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16} = $ctx;
  return [$cmp.isSupportedListing ? api_element("div", {
    classMap: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.summaryClass),
    attrs: stc1,
    key: 1
  }, [api_element("div", stc2, [api_custom_element("ax-image", _axImage, {
    className: api_normalize_class_name($cmp.summaryLogoClass),
    props: {
      "imgSrc": $cmp.logo,
      "width": "84px",
      "height": "84px",
      "alt": $cmp.logoAlt,
      "variant": "rounded"
    },
    key: 3
  })]), api_element("div", stc3, [api_element("div", stc4, [api_element("div", stc5, [api_static_fragment($fragment1, 8, [api_static_part(1, null, api_dynamic_text($cmp.listing.name))]), $cmp.shouldShowBetaBadge ? api_custom_element("wds-status-badge", _wdsStatusBadge, stc6) : null]), $cmp.shouldShowFavoriteButton ? api_custom_element("wds-icon-interactive", _wdsIconInteractive, {
    className: api_normalize_class_name($cmp.favoriteButtonClassName),
    attrs: stc7,
    props: {
      "icon": $cmp.favoriteButtonIcon,
      "iconDescription": $cmp.favoriteButtonIconDescription,
      "ariaLabel": $cmp.favoriteButtonIconDescription,
      "spriteUrl": "/images/icons.svg",
      "name": $cmp.favoriteButtonAnalyticsName,
      "transparentBackground": "true"
    },
    key: 10,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleFavoriteListings))
    }
  }) : null])]), $cmp.hasSearchBlurb ? api_static_fragment($fragment2, 12, [api_static_part(2, null, api_dynamic_text($cmp.searchBlurb))]) : null, $cmp.isClaudeforceListing ? api_static_fragment($fragment3, 14) : null, $cmp.shouldShowAwardDeck ? api_custom_element("listing-award-deck", _listingAwardDeck, {
    classMap: stc8,
    props: {
      "cards": $cmp.providerAchievementCards
    },
    key: 15
  }) : null]), $cmp.showOfferRequestSuccessNotification ? api_custom_element("listing-banner-v2", _listingBannerV2, {
    attrs: stc9,
    props: {
      "message": $cmp.offerRequestSuccessMessage,
      "bannerRole": "status",
      "variant": "offer"
    },
    key: 16
  }) : null, $cmp.isPrivateListing ? api_custom_element("listing-banner-v2", _listingBannerV2, {
    attrs: stc10,
    props: {
      "message": $cmp.privateBannerMessage
    },
    key: 17
  }) : null, api_element("div", {
    className: api_normalize_class_name($cmp.collapsedNavClass),
    attrs: {
      "data-testid": "collapsed-nav",
      "aria-hidden": $cmp.collapsedNavAriaHidden
    },
    key: 18
  }, [api_element("div", stc11, [api_element("div", stc12, [api_element("div", stc13, [api_element("div", stc14, [api_custom_element("ax-image", _axImage, {
    className: api_normalize_class_name($cmp.collapsedLogoClass),
    props: {
      "imgSrc": $cmp.logo,
      "alt": $cmp.logoAlt,
      "variant": "rounded",
      "width": "32px",
      "height": "32px"
    },
    key: 23
  }), api_static_fragment($fragment4, 25, [api_static_part(1, null, api_dynamic_text($cmp.listing.name))])]), $cmp.hasCollapsedOnce ? api_custom_element("wds-tab-group-v2", _wdsTabGroupV2, {
    attrs: stc15,
    props: {
      "tabs": $cmp.tabs,
      "mobile": $cmp.isMobileOrTablet,
      "flush": $cmp.collapsedTabGroupFlush,
      "dropdownFullBleed": $cmp.isMobileOrTablet,
      "idNamespace": "collapsed-"
    },
    key: 26,
    on: {
      "tabregister": _m2 || ($ctx._m2 = api_bind($cmp.handleTabRegister)),
      "tabchange": _m3 || ($ctx._m3 = api_bind($cmp.handleTabChange)),
      "keydown": _m4 || ($ctx._m4 = api_bind($cmp.handleTabGroupKeyDown))
    }
  }) : null])])])]), api_element("div", stc16, [api_element("aside", stc17, [$cmp.showInstallCard ? api_element("div", stc18, [$cmp.isSkillListing ? api_custom_element("listing-skill-sidebar", _listingSkillSidebar, {
    props: {
      "listing": $cmp.listing
    },
    key: 30,
    on: {
      "marketplaceinstallstatechange": _m5 || ($ctx._m5 = api_bind($cmp.handleInstallStateChange))
    }
  }) : null, $cmp.isPluginListing ? api_custom_element("listing-plugin-sidebar", _listingPluginSidebar, {
    props: {
      "listing": $cmp.listing,
      "requestBetaAccess": $cmp.showClaudeforceBetaAccess
    },
    key: 31,
    on: {
      "marketplaceinstallstatechange": _m6 || ($ctx._m6 = api_bind($cmp.handleInstallStateChange))
    }
  }) : null]) : null, $cmp.showPriceCtaCard ? api_element("div", {
    classMap: stc19,
    key: 32,
    on: {
      "analytics": _m7 || ($ctx._m7 = api_bind($cmp.handlePricingCtaAnalytics))
    }
  }, [$cmp.showListingPrice ? api_element("div", stc20, [api_custom_element("listing-pricing-summary-v2", _listingPricingSummaryV2, {
    props: {
      "pricing": $cmp.pricingPlan
    },
    key: 34,
    on: {
      "linkclick": _m8 || ($ctx._m8 = api_bind($cmp.handlePricingSummaryLinkClick))
    }
  })]) : null, api_element("div", {
    classMap: stc21,
    key: 35,
    on: {
      "analytics": _m9 || ($ctx._m9 = api_bind($cmp.handleActionsAnalytics))
    }
  }, [$cmp.showLeadCtas ? !$cmp.isConsultantListing ? $cmp.isListingW9Compliant ? api_custom_element("wds-button", _wdsButton, {
    attrs: stc22,
    props: {
      "width": "fill",
      "label": $cmp.i18n.listingDetails.getItNowButtons.getItNow,
      "variant": "primary",
      "name": "get it now"
    },
    key: 36,
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.handleGetItNowCTA))
    }
  }) : null : null : null, $cmp.showLeadCtas ? !$cmp.isConsultantListing ? !$cmp.isListingW9Compliant ? api_custom_element("ax-tooltip", _axTooltip, {
    props: {
      "theme": "dark",
      "label": $cmp.i18n.listingDetails.getItNowButtons.helpTextForGetItNowDisabled,
      "placement": "top"
    },
    key: 37
  }, [api_custom_element("wds-button", _wdsButton, {
    attrs: stc23,
    props: {
      "width": "fill",
      "label": $cmp.i18n.listingDetails.getItNowButtons.getItNowDisabled,
      "variant": "primary",
      "disabled": true,
      "name": "get it now disabled"
    },
    key: 38
  })]) : null : null : null, $cmp.showLeadCtas ? !$cmp.isConsultantListing ? $cmp.hasTrialOptions ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc24,
    props: {
      "width": "fill",
      "href": $cmp.tryButtonHref,
      "label": $cmp.i18n.listingDetails.getItNowButtons.tryForFree,
      "variant": "secondary",
      "name": "try it free"
    },
    key: 39
  }) : null : null : null, $cmp.showLeadCtas ? !$cmp.isConsultantListing ? $cmp.showRequestPrivateOfferButton ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc25,
    attrs: stc26,
    props: {
      "width": "fill",
      "label": $cmp.i18n.listingDetails.getItNowButtons.requestPrivateOffer,
      "variant": "tertiary",
      "name": "request private offer"
    },
    key: 40,
    on: {
      "click": _m11 || ($ctx._m11 = api_bind($cmp.handleRequestPrivateOfferClick))
    }
  }) : null : null : null, $cmp.showLeadCtas ? $cmp.showLearnMoreButton ? api_custom_element("wds-button", _wdsButton, {
    attrs: stc27,
    props: {
      "width": "fill",
      "label": $cmp.i18n.shared.learnMore,
      "variant": "primary",
      "name": "learn more"
    },
    key: 41,
    on: {
      "click": _m12 || ($ctx._m12 = api_bind($cmp.handleLearnMoreCTA))
    }
  }) : null : null])]) : null, api_custom_element("listing-metadata-card-v2", _listingMetadataCardV2, {
    props: {
      "listing": $cmp.listing
    },
    key: 42
  }), api_element("div", stc28, [$cmp.displayChat ? api_custom_element("ace-qualified-chat", _aceQualifiedChat, {
    props: {
      "chattoken": $cmp.chatToken,
      "usertoken": $cmp.userToken
    },
    key: 44
  }) : null])]), api_element("div", stc29, [api_element("div", stc30, [$cmp.showClaudeforceBetaSignupSuccess ? api_custom_element("ax-scoped-notification", _axScopedNotification, {
    attrs: stc31,
    props: {
      "theme": "success",
      "ariaLive": "polite",
      "scopedNotificationTitle": $cmp.claudeforceBetaSignupSuccessTitle,
      "scopedNotificationMessage": $cmp.claudeforceBetaSignupSuccessMessage
    },
    key: 47
  }) : null, api_element("div", stc32, [api_custom_element("wds-tab-group-v2", _wdsTabGroupV2, {
    attrs: stc33,
    props: {
      "tabs": $cmp.tabs,
      "mobile": $cmp.isMobileOrTablet
    },
    key: 49,
    on: {
      "tabregister": _m13 || ($ctx._m13 = api_bind($cmp.handleTabRegister)),
      "tabchange": _m14 || ($ctx._m14 = api_bind($cmp.handleTabChange)),
      "keydown": _m15 || ($ctx._m15 = api_bind($cmp.handleTabGroupKeyDown))
    }
  })])]), $cmp.showStandardOverview ? api_custom_element("listing-overview-v2", _listingOverviewV2, {
    attrs: stc34,
    props: {
      "id": api_scoped_id("overview-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing,
      "carouselItems": $cmp.carouselItems,
      "hasDemoItem": $cmp.hasDemoItem,
      "watchDemoUrl": $cmp.watchDemoUrl,
      "watchDemoPreviewUrl": $cmp.watchDemoPreviewUrl,
      "hasDemoLeadsEnabled": $cmp.hasDemoLeadsEnabled,
      "isMobilePhone": $cmp.isMobilePhone
    },
    key: 50
  }) : null, $cmp.showSkillOverview ? api_custom_element("listing-skill-overview", _listingSkillOverview, {
    attrs: stc35,
    props: {
      "id": api_scoped_id("skill-overview-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 51
  }) : null, $cmp.showSecurity ? api_deprecated_dynamic_component("listing-security", $cmp.securityPanelCtor, {
    attrs: stc36,
    props: {
      "id": api_scoped_id("security-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 52
  }) : null, $cmp.showCompetencies ? api_custom_element("listing-competencies-v2", _listingCompetenciesV2, {
    attrs: stc37,
    props: {
      "id": api_scoped_id("competencies-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 53
  }) : null, $cmp.showForceSpecs ? api_deprecated_dynamic_component("listing-specs", $cmp.specsPanelCtor, {
    attrs: stc38,
    props: {
      "id": api_scoped_id("specs-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing,
      "prerequisiteListing": $cmp.prerequisiteListing
    },
    key: 54
  }) : null, $cmp.showPluginSpecs ? api_custom_element("listing-plugin-specs", _listingPluginSpecs, {
    attrs: stc39,
    props: {
      "id": api_scoped_id("plugin-specs-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 55
  }) : null, $cmp.showFoundIn ? api_custom_element("listing-skill-found-in", _listingSkillFoundIn, {
    attrs: stc40,
    props: {
      "id": api_scoped_id("found-in-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 56
  }) : null, $cmp.showReviews ? api_deprecated_dynamic_component("listing-reviews-v2", $cmp.reviewsPanelCtor, {
    attrs: stc41,
    props: {
      "id": api_scoped_id("reviews-panel"),
      "role": "tabpanel",
      "reviewSummary": $cmp.reviewSummary
    },
    key: 57,
    on: {
      "reviewsfiltered": _m16 || ($ctx._m16 = api_bind($cmp.handleReviewsFiltered))
    }
  }) : null, $cmp.showPricing ? api_custom_element("listing-pricing-v2", _listingPricingV2, {
    attrs: stc42,
    props: {
      "id": api_scoped_id("pricing-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 58
  }) : null, $cmp.showResources ? api_custom_element("listing-more-resources-v2", _listingMoreResourcesV2, {
    attrs: stc43,
    props: {
      "id": api_scoped_id("resources-panel"),
      "role": "tabpanel",
      "resources": $cmp.listingResources
    },
    key: 59
  }) : null, $cmp.showSupport ? api_custom_element("listing-support", _listingSupport, {
    attrs: stc44,
    props: {
      "id": api_scoped_id("support-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 60
  }) : null, $cmp.showPackageFiles ? api_custom_element("listing-skill-package-files", _listingSkillPackageFiles, {
    attrs: stc45,
    props: {
      "id": api_scoped_id("packageFiles-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 61
  }) : null])]), $cmp.showRelatedSkills ? api_custom_element("listing-related-skills", _listingRelatedSkills, {
    attrs: stc46,
    props: {
      "listing": $cmp.listing
    },
    key: 62
  }) : null, $cmp.showMoreFromProvider ? api_custom_element("listing-more-from-this-provider-v2", _listingMoreFromThisProviderV2, {
    attrs: stc47,
    props: {
      "providerName": $cmp.publisherName
    },
    key: 63
  }) : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2ps4ehm27rh";
tmpl.legacyStylesheetToken = "undefined-_listingDetailV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
